import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import MoreStoriesButton from '../components/common/more_stories_button';
import SlimcutAdTag from '../components/ad/slimcut_ad_tag';
import { WATCH_HOME_IDS } from '../constants';
import {get} from 'lodash';

const options = {
  displayName: 'ChannelContainer',

  contentBelowModules() {
    const shouldRenderMoreStoriesButton =
      !!get(this.props, 'api.pagination.next');

    return (
      <div>
        {
          shouldRenderMoreStoriesButton &&
          <MoreStoriesButton
            api={this.props.api}
            fetchFoundryResponse={this.props.fetchFoundryResponse}
          />
        }
        <SlimcutAdTag
          adPageType={this.props.adsState.ad_data.ad_page_type}
          adTargetingCompleted={this.props.adsState.adTargetingCompleted}
        />
      </div>
    );
  },

  shouldDisplayHeaderAd() {
    return true;
  },

  shouldDisplayInvertedStyles() {
    return WATCH_HOME_IDS.includes(this.props.analytics.type_id);
  },

  shouldDisplayCondensedModules() {
    return WATCH_HOME_IDS.includes(this.props.analytics.type_id);
  }
};

export const ChannelContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
